import React from 'react'
import { SVGProps } from 'react'

const AuctionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M9.19819 12.6128H1.20142C0.538194 12.6128 0 13.1509 0 13.8142V15.9989H10.3996V13.8142C10.3996 13.1509 9.86141 12.6128 9.19819 12.6128Z" />
      <path d="M15.7847 12.7823L8.48504 5.48261L9.89497 4.07518C10.1275 4.28018 10.485 4.27015 10.7049 4.05018C10.9349 3.8177 10.9349 3.44519 10.7049 3.21271L7.66508 0.175335C7.43508 -0.0571428 7.0601 -0.0571428 6.83012 0.175335C6.59765 0.405338 6.59765 0.780323 6.83012 1.01029L6.80513 0.985295L2.94526 4.84263L2.97026 4.8701C2.74025 4.63762 2.36527 4.63762 2.1353 4.8701C1.90282 5.1001 1.90282 5.47509 2.1353 5.70509L5.17267 8.74494C5.40515 8.97495 5.78013 8.97495 6.01014 8.74494C6.24014 8.51246 6.24014 8.13998 6.01014 7.90754L6.03514 7.93247L7.44507 6.52504L14.7423 13.8223C15.0298 14.1098 15.4973 14.1098 15.7847 13.8223C16.0722 13.5348 16.0722 13.0698 15.7847 12.7823Z" />
    </g>
  </svg>
)
export default AuctionIcon
